
import { SelectOption } from '~ui-kit';

export const getBusinessUnitsSelectOptions = (businessUnits: string[]): SelectOption[] =>
  businessUnits.map((businessUnit: string, i) => ({ value: String(i), label: businessUnit }));
